// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Star_wrap__xtdaE","image":"Star_image__2FKSe"};